// removed by extract-text-webpack-plugin
module.exports = {"icon-positioning":"_20igp","tooltip-click-wrapper":"_1JcAY","tooltip":"_1xzhV","tooltip--open":"_3sOyq","tooltip-hover-wrapper":"KeKQN","tooltip-right":"_3ts1Y","tooltip-left":"_1i7ZQ","tooltip-bottom":"Chgsa","tooltip-top":"_1yDAI","arrow-bottom":"k0QLI","arrow-top":"_2ABLl","arrow-right":"_1Z7j1","arrow-left":"_3liDF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/InfoWithTooltip/ConfigurableDesktopTooltip.scss
// module id = ./src/components/InfoWithTooltip/ConfigurableDesktopTooltip.scss
// module chunks = 4